export default __webpack_public_path__ + "static/media/3.ffeaabe9.svg";